import { axiosPost } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import {
  CreateRewardPeriodRequest,
  CreateEstimatedRewardRequest,
  CreateManualRewardRequest,
} from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 리워드 기간 생성
export const createRewardPeriod = async (data: CreateRewardPeriodRequest) => {
  const payload: EndpointPayload = {
    path: '/assetfi/staking/rewards/periods',
    body: data,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'createRewardPeriod', axiosPost);
};

// 예상 리워드 생성
export const createEstimatedReward = async (data: CreateEstimatedRewardRequest) => {
  const payload: EndpointPayload = {
    path: '/assetfi/staking/rewards/estimated',
    body: data,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'createEstimatedReward', axiosPost);
};

// 수동 리워드 지급
export const createManualReward = async (data: CreateManualRewardRequest) => {
  const payload: EndpointPayload = {
    path: '/assetfi/admin/staking/rewards',
    body: data,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'createManualReward', axiosPost);
};
